<form [formGroup]="addressForm">

	<!-- Street	-->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.street?.addSpaceToPrevious"
		[config]="formConfigData.street"
		[disableControl]="disableControls?.includes('street')"
		[formEntityId]="'street'"
		[formGroup]="addressForm"
		[hideErrors]="hideErrors"
		[hideErrorDescriptions]="hideErrorDescriptions"
		[isRequired]="hasRequiredValidator('street')"
	></app-form-input>

	<!-- House Number	-->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.houseNumber?.addSpaceToPrevious"
		[config]="formConfigData.houseNumber"
		[disableControl]="disableControls?.includes('houseNumber')"
		[formEntityId]="'houseNumber'"
		[formGroup]="addressForm"
		[hideErrors]="hideErrors"
		[hideErrorDescriptions]="hideErrorDescriptions"
		[isRequired]="hasRequiredValidator('houseNumber')"
	></app-form-input>

	<!-- AdditionalData	-->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.additionalData?.addSpaceToPrevious"
		[config]="formConfigData.additionalData"
		[disableControl]="disableControls?.includes('additionalData')"
		[formEntityId]="'additionalData'"
		[formGroup]="addressForm"
		[hideErrors]="hideErrors"
		[hideErrorDescriptions]="hideErrorDescriptions"
		[isRequired]="hasRequiredValidator('additionalData')"
	></app-form-input>

	<!-- City	-->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.city?.addSpaceToPrevious"
		[config]="formConfigData.city"
		[disableControl]="disableControls?.includes('city')"
		[formEntityId]="'city'"
		[formGroup]="addressForm"
		[hideErrors]="hideErrors"
		[hideErrorDescriptions]="hideErrorDescriptions"
		[isRequired]="hasRequiredValidator('city')"
	></app-form-input>

	<!-- PostalCode	-->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.postalCode?.addSpaceToPrevious"
		[config]="formConfigData.postalCode"
		[disableControl]="disableControls?.includes('postalCode')"
		[formEntityId]="'postalCode'"
		[formGroup]="addressForm"
		[hideErrors]="hideErrors"
		[hideErrorDescriptions]="hideErrorDescriptions"
		[isRequired]="hasRequiredValidator('postalCode')"
	></app-form-input>

	<!-- FederalState	-->
	<app-form-input
		[addSpaceToPrevious]="!!formConfigData?.state?.addSpaceToPrevious"
		[config]="formConfigData.state"
		[disableControl]="disableControls?.includes('state')"
		[formEntityId]="'state'"
		[formGroup]="addressForm"
		[hideErrors]="hideErrors"
		[hideErrorDescriptions]="hideErrorDescriptions"
		[isRequired]="hasRequiredValidator('state')"
	></app-form-input>

	<!-- Country Code -->
	<app-country
		[allowedContinents]="addressFormConfig?.country?.allowedContinents"
		[allowedCountries]="addressFormConfig?.country?.allowedCountries"
		[allowCurrent]="addressFormConfig?.country?.showOnly === 'currentAndAllowed'"
		[excludedContinents]="addressFormConfig?.country?.excludedContinents"
		[excludedCountries]="addressFormConfig?.country?.excludedCountries"
		[countryControl]="this.addressForm.get( 'countryCode' )"
		[disabledContinents]="addressFormConfig?.country?.disabledContinents"
		[disabledCountries]="addressFormConfig?.country?.disabledCountries"
		(countryListEvent)="onCountryListEvent( $event )"
	>
		<app-form-select
			bindLabel="nameLocalized"
			bindValue="countryIdentifier"
			[addSpaceToPrevious]="!!formConfigData?.countryCode?.addSpaceToPrevious"
			[config]="formConfigData.countryCode"
			[disableControl]="disableControls?.includes('countryCode')"
			[formEntityId]="'countryCode'"
			[formGroup]="addressForm"
			[groupBy]="'continentLocalized'"
			[hideErrors]="hideErrors"
			[hideErrorDescriptions]="hideErrorDescriptions"
			[isRequired]="hasRequiredValidator('countryCode')"
			[itemList]="countryList"
			[searchable]="true"
			[virtualScroll]="true"
		></app-form-select>
	</app-country>
</form>
